import React from 'react';
import { CenterFrameLayout } from 'Layouts';
import { PrimaryText } from 'Components/Texts';
import { Link } from 'react-router-dom';

export const ConfirmSignIn = ({ routes }) => {
  return (
    <CenterFrameLayout title="Your Password Has Been Updated" showLoader={false}>
      <div className="roundContentContainer">
        <div className="roundContentContainer">
          <Link to={routes.signin} className="blueLink">
            Click here to sign in
          </Link>
        </div>
      </div>
    </CenterFrameLayout>
  );
};
